import { render, staticRenderFns } from "./UtilFinanceSharersTable.vue?vue&type=template&id=1b3bb0c0"
import script from "./UtilFinanceSharersTable.vue?vue&type=script&lang=js"
export * from "./UtilFinanceSharersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports